export default "__VITE_ASSET__CK59Mk9Z__"